import script from "./PostersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PostersPage.vue?vue&type=script&setup=true&lang=js"

import "./PostersPage.vue?vue&type=style&index=0&id=0ffb9dcf&scoped=true&lang=css"
import "./PostersPage.vue?vue&type=style&index=1&id=0ffb9dcf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ffb9dcf"]])

export default __exports__